import { Pipe, PipeTransform } from "@angular/core";
import { FormArray, FormControl, Validators } from "@angular/forms";

@Pipe({
  name: "isRequired",
  standalone: true,
})
export class IsRequiredPipe implements PipeTransform {
  transform(control: FormControl | FormArray): boolean {
    if (control) return control.hasValidator(Validators.required);
    return false;
  }
}
